import { Label, Popup } from "semantic-ui-react";

type IdeaDisplayField = { id: string; title: string; value: string };

type IdeaDisplayFieldsProps = {
  fields: IdeaDisplayField[];
  showBorder?: boolean;
};

const IdeaDisplayFields = ({ fields }: IdeaDisplayFieldsProps) => {
  if (!fields.length) return null;
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
      <div
        style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "4px" }}
      >
        {fields.map((field) => (
          <Popup
            key={field.id}
            position="right center"
            content={
              <div>
                <b>{field.title}</b>
                <div>
                  {field.type === "optionMultiple" ?
                    field.value.join(", ")
                  : field.value}
                </div>
              </div>
            }
            trigger={
              <Label
                basic
                size="tiny"
                style={{
                  width: "100%",
                  margin: 0,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {field.type === "optionMultiple" ?
                  field.value.join(", ")
                : field.value}
              </Label>
            }
          />
        ))}
      </div>
    </div>
  );
};

export default IdeaDisplayFields;
